import React from "react";

export default function Admin({ planes,handleDeleteMessage }) {
    function handleDelete(id){
        console.log(`Clicked i plane with id ${id}`)
        fetch(`https://flask-api-dlzd.onrender.com/aircrafts/${id}`,{
            method:"DELETE",
            headers:{"Content-Type":"application/json"}
        })
        handleDeleteMessage(id)
    }
  return (
    <div className="admin-section">
      <h1 className="title">Hello Azhar! Welcome To The Admin Section</h1>
      <div className="cards-container">
        {planes.map((plane) => (
          <div className="card2" key={plane.id}>
            <img src={plane.image} alt="Airplane" className="card-image" />
            <div className="card-content">
              <p className="airline2">Airline: {plane.airline}</p>
              <p className="aircraft-model2">Aircraft Model: {plane.aircraft_model}</p>
              <p className="capacity2">Capacity: {plane.capacity}</p>
              <p className="departure2">Departure: {plane.departure}</p>
              <p className="destination2">Destination: {plane.destination}</p>
              <p className="flight-duration2">Flight Duration: {plane.flight_duration}</p>
              <div className="card-buttons2">
                <button className="edit-button2" style={{backgroundColor:"green"}}>Edit</button>
                <button className="delete-button2" style={{backgroundColor:"red"}} onClick={()=>handleDelete(plane.id)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
